<div class="min-h-screen flex items-center justify-center bg-gray-50 p-4">
  <mat-card class="w-full max-w-sm p-6">
    <h2 class="text-2xl font-bold text-center mb-6">Reset Password</h2>

    <div *ngIf="success" class="text-center py-4">
      <mat-icon class="text-green-500" style="font-size:48px">check_circle</mat-icon>
      <p class="mt-2 text-gray-600">Password reset! Redirecting to login...</p>
    </div>

    <form *ngIf="!success" [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field class="w-full mb-4">
        <mat-label>New Password</mat-label>
        <input matInput formControlName="newPassword" [type]="hidePassword ? 'password' : 'text'">
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('newPassword')?.hasError('minlength')">Minimum 8 characters</mat-error>
      </mat-form-field>

      <mat-form-field class="w-full mb-4">
        <mat-label>Confirm Password</mat-label>
        <input matInput formControlName="confirmPassword" [type]="hidePassword ? 'password' : 'text'">
        <mat-error *ngIf="form.hasError('mismatch')">Passwords do not match</mat-error>
      </mat-form-field>

      <button mat-raised-button color="primary" class="w-full" type="submit" [disabled]="loading || form.invalid">
        <mat-spinner *ngIf="loading" diameter="20" class="inline-block mr-2"></mat-spinner>
        Reset Password
      </button>
    </form>
  </mat-card>
</div>
